/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class RecommendationExclusionRule extends models.RecommendationExclusionRuleBase {
    getFixupPrototypeFunction() { return RecommendationExclusionRule.fixupPrototype; }

    static newInstance(model: Partial<RecommendationExclusionRule>): RecommendationExclusionRule {
        let obj = Object.assign(new RecommendationExclusionRule(), model);
        RecommendationExclusionRule.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<RecommendationExclusionRule>): RecommendationExclusionRule {
        if (!model) return null;
        return RecommendationExclusionRule.newInstance(<RecommendationExclusionRule> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: RecommendationExclusionRule) {
        if (!obj) return;

        models.RecommendationExclusionRule.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: RecommendationExclusionRule): boolean {
        if (models.RecommendationExclusionRuleBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, RecommendationExclusionRule.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (typeof this.created_at === "string") {
            this.created_at = new Date(<string><any>this.created_at);
        }
        if (typeof this.updated_at === "string") {
            this.updated_at = new Date(<string><any>this.updated_at);
        }
        if (this.policy_classification) {
            models.PolicyClassificationWithSubClassifications.fixupPrototype(this.policy_classification);
        }
    }

    policy_classification: models.PolicyClassificationWithSubClassifications;

    /**
     * ID of the Rule
     */
    rule_id: string;

    /**
     * Name of the user who created the rule.
     */
    created_by: string;

    /**
     * Recommendation exclusion rule created time
     */
    created_at: Date;

    /**
     * Name of the user who recently updated the rule.
     */
    updated_by: string;

    /**
     * Recommendation exclusion rule updated time
     */
    updated_at: Date;

}
